<template>
    <v-snackbar v-model="show.openSnackbar">
        {{ show.description }}

        <template v-slot:actions>
            <v-btn color="indigo-darken-3" variant="text" @click="show.openSnackbar = false">
                Cerrar
            </v-btn>
        </template>
    </v-snackbar>
</template>
<script>
export default {
    name: "SnackbarComponent",
    props: {
        value: {
            openSnackbar: Boolean,
            description: String,
        },
    },
    data: () => ({}),
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
};
</script>
